@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.dpi-explanation {
  opacity: 0;
  height: 0;
  transition: all 300ms ease;
  padding: 10px;
}

.open {
  height: auto;
  opacity: 1;
}

.dpi-text {
  font-size: 13px;
  padding: 10px;
}

.acknowledge-button {
  border: 1px solid @settings-page--printing-setup-options-label-dpi-button--border-color;
  border-radius: 5px;
  padding: 10px;
  cursor: pointer;

  &:hover {
    @background-color: @settings-page--printing-setup-options-label-dpi-button--hover--background-color;
  }
}

.dpi-text-title {
  background-color: @settings-page--printing-setup-options-label-dpi-text-title--background-color;
  padding: 10px;
}

.description {
  font-size: 16px;
  padding: 20px 0 10px;
  font-weight: @bold;
  border-bottom: 1px solid @settings-page--printing-setup-options-label-dpi-title--border-color;
  margin-bottom: 10px;
}

.print-option {
  padding-bottom: 15px;
  display: grid;
  font-size: 13px;
  row-gap: 10px;
}

.options-grid {
  display: grid;
  width: 100%;
  grid-template-columns: auto 1fr;
  column-gap: 15px;
  align-items: center;

  .message-label {
    align-self: start;
    padding-top: 10px;
  }
}

.no-border {
  && button {
    border: 0;
  }
}
